<script>
import FormComponent from './Form/component.vue';
import FilterComponent from './Filter/component.vue';
import ItemComponent from './Item/component.vue';

export default {
  components: {
    FormComponent,
    FilterComponent,
    ItemComponent,
  },
  props: {
    module: {
      type: Object,
    },
    link: String,
  },
  data: () => ({
    init: false,
  }),
  methods: {
    handlerSubmit() {
      this.module.submit()
        .finally(() => {
          this.init = true;
          setTimeout(() => {
            this.$refs.list.scrollIntoView();
          });
        });
    },
  },
};
</script>
<template>
  <div class="p-t-c-l">
    <div class="p-t-c-l__form">
      <FormComponent
        :module="module.form"
        @submit="handlerSubmit"
      />
    </div>
    <div class="mag-scroll-top" ref="list"></div>
    <div class="p-t-c-l__flex" v-if="init">
      <div
        v-if="module.__items.length"
        class="p-t-c-l__filter"
      >
        <FilterComponent
          :module="module.filter"
        />
      </div>
      <div class="p-t-c-l__items">
        <ItemComponent
          v-for="item in module.items"
          :key="item.id"
          :item="item"
          :link="link"
          class="p-t-c-l__item"
        />
        <div
          v-if="!module.__items.length"
          class="p-t-c-l__error"
        >Туры не найдены
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
  .p-t-c-l {
    &__flex {
      display: flex;
    }

    &__filter {
      width: 300px;
      flex-shrink: 0;
      margin: 0 24px 0 0;
    }

    &__items {
      flex: 1;
    }

    &__error {
      text-align: center;
      padding: 36px;
    }
  }

  @media (max-width: 1000px) {
    .p-t-c-l__filter {
      display: none;
    }
  }
</style>
